var _excluded = ["children", "text", "onSuccess", "onError"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ClipboardJS from 'clipboard';

var noop = function noop() {};

function CopyToClipboard(_ref) {
  var children = _ref.children,
      text = _ref.text,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? noop : _ref$onSuccess,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? noop : _ref$onError,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var ref = useRef();
  useEffect(function () {
    var clipboard = new ClipboardJS(ref.current);
    clipboard.on('success', onSuccess);
    clipboard.on('error', onError);
    return function () {
      clipboard.destroy();
    };
  }, [onError, onSuccess]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props, {
    "data-clipboard-text": text
  }), children);
}

CopyToClipboard.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  text: PropTypes.string.isRequired
} : {};
export default CopyToClipboard;